 
import _ from 'underscore'

import service from '../service/me'
import MECONSTANT from '../constant/me'

export default {
  getMeDetail ({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getMeDetail().then(data => {
        resolve(data)
        commit(MECONSTANT.ME_GET_DETAIL_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(MECONSTANT.ME_GET_DETAIL_ERROR, e)
      })
    })
  },
  getUserPageData ({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getUserPageData().then(data => {
        resolve(data)
        commit(MECONSTANT.ME_GET_PAGE_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(MECONSTANT.ME_GET_PAGE_ERROR, e)
      })
    })
  },
  updateUserInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return service.updateUserInfo(payload).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  sendFeedback({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return service.sendFeedback(payload).then(data => {
        resolve(data)
        commit(MECONSTANT.ME_FEEDBACK_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(MECONSTANT.ME_FEEDBACK_ERROR, data)
      })
    })
  },
  uploadHeadIcon({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return service.uploadHeadIcon(payload).then(data => {
        resolve(data)
        // commit(MECONSTANT.ME_UPLOAD_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        // commit(MECONSTANT.ME_FEEDBACK_ERROR, data)
      })
    })
  },
  getNoWatchCount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return service.getNoWatchCount().then(data => {
        resolve(data)
        commit(MECONSTANT.ME_NO_WATCH_COUNT_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(MECONSTANT.ME_NO_WATCH_COUNT_ERROR, e)
      })
    })
  },
  readNoWatchCount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return service.readNoWatchCount().then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
}
